import styled from 'styled-components';
import Box from 'common/components/Box';

export const Container = styled.div`
  width: 100%;
  margin: 3vh auto;
`;

export const AuthorContainer = styled(Box)`
  width: 100%;
  background-color: #f3f4ef;
  border-radius: 8px;
  display: flex;
  padding: 20px;
  display: flex;
  align-items: center;
`;
